<template>
  <div class="log">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page2"
        :data="tableData2"
        :key="tableKey"
        :table-loading="tableLoading2"
        :option="tableOption2"
        :permission="permissionList2"
        @on-load="getPage2"
        @search-change="searchChange2"
        @refresh-change="refreshChange2"
        @sort-change="sortChange2"
        @row-del="handleDel2"
      >
      <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange2(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              @click="exOut"
            >
              导出
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {pageByUserId as getPage2, delObj as delObj2} from '@/api/upms/loglogin'
import {tableOption as tableOption2} from '@/const/crud/upms/loglogin'

export default {
  data() {
    return {
      tableKey:0,
      tableData2: [],
      page2: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [],
        descs: "create_time",
      },
      tableLoading2: false,
      tableOption2: tableOption2,
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList2() {
      return {
        addBtn: this.permissions["sys:loglogin:add"] ? true : false,
        delBtn: this.permissions["sys:loglogin:del"] ? true : false,
        editBtn: this.permissions["sys:loglogin:edit"] ? true : false,
        viewBtn: this.permissions["sys:loglogin:get"] ? true : false,
      };
    },
  },
  mounted: function () {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  methods: {
    updateTableHeight() {
        this.tableOption2.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        // console.info(this.tableOption.height)
        this.tableKey += 1
    },
    exOut(){
      this.$refs.crud.rowExcel()
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange2(params, done) {
      params = this.filterForm(params);
      this.page2.currentPage = 1;
      this.getPage2(this.page2, params);
      // done();
    },
    sortChange2(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page2.descs = [];
        this.page2.ascs = prop;
      } else if (val.order == "descending") {
        this.page2.ascs = [];
        this.page2.descs = prop;
      } else {
        this.page2.ascs = [];
        this.page2.descs = [];
      }
      this.getPage2(this.page2);
    },
    getPage2(page, params) {
      this.tableLoading2 = true;
      getPage2(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page2.descs,
            ascs: this.page2.ascs,
            // createId: this.userInfo.id
          },
          params
        )
      )
        .then((response) => {
          this.tableData2 = response.data.data.records;
          this.page2.total = response.data.data.total;
          this.page2.currentPage = page.currentPage;
          this.page2.pageSize = page.pageSize;
          this.tableLoading2 = false;
        })
        .catch(() => {
          this.tableLoading2 = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel2: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj2(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage2(this.page2);
        })
        .catch(function (err) {});
    },
    /**
     * 刷新回调
     */
    refreshChange2(page) {
      this.getPage2(this.page2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.reset{
  margin-left: 14px;
}
/deep/.el-icon-printer{
  display: none!important;
}
.headerContent{
  margin-left: 55px;
}
</style>